const colors = {
    white: 0xffffff,
    black: 0x000000,
    magenta: 0xA000FF,
    green: 0x00FF00,
    red: 0xFF002D,
    blue: 0x00FFFA
}

export default colors